import { useNavigate } from 'react-router-dom'
import { Box, HStack, Icon, Text } from '@chakra-ui/react';

interface ToolCardProps {
  icon: React.ElementType
  label: string
  description: string
  to: string
}

export function ToolCard({ icon, label, description, to }: ToolCardProps) {
  const navigate = useNavigate()
  return (
    <Box
      bg="surface"
      p={4}
      borderRadius="lg"
      border="1px"
      borderColor="gray.200"
      cursor="pointer"
      _hover={{ borderColor: 'accent', shadow: 'sm' }}
      transition="all 0.2s"
      onClick={() => navigate(to)}
    >
      <HStack gap={3}>
        <Icon as={icon} boxSize={5} color="accent" />
        <Box>
          <Text fontWeight="medium" fontSize="sm">{label}</Text>
          <Text fontSize="xs" color="gray.500">{description}</Text>
        </Box>
      </HStack>
    </Box>
  );
}
